import { render, staticRenderFns } from "./SeeStudentLive.vue?vue&type=template&id=7a7bcabb&scoped=true"
import script from "./SeeStudentLive.vue?vue&type=script&lang=js"
export * from "./SeeStudentLive.vue?vue&type=script&lang=js"
import style0 from "./SeeStudentLive.vue?vue&type=style&index=0&id=7a7bcabb&prod&scoped=true&lang=scss"
import style1 from "./SeeStudentLive.vue?vue&type=style&index=1&id=7a7bcabb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7bcabb",
  null
  
)

export default component.exports